export const TITLES_WITH_LINE_TYPES_CLASS = `titles-with-line-types`;
export const TOPIC_TITLE_CLASS = `topic-title`;
export const NUMBER_OF_ORDERED_TOPICS = {
  FIRST: 0,
  SECOND: 1,
  THIRD: 2,
};



// WEBPACK FOOTER //
// ./src/features/home/components/constants/TitlesWithLineTypesConstants.js